import React, { useState, useEffect } from 'react';
// Shows today's warnings from logs/ALERT_*.log (failed backup, broken OI shortlist, ...). Renders nothing when all is well.
export default function AlertBanner() {
  const [a, setA] = useState([]);
  useEffect(() => {
    const load = async () => { try { const r = await fetch('/opendrive/alerts'); const j = await r.json(); setA(j.alerts || []); } catch (e) {} };
    load(); const t = setInterval(load, 60000); return () => clearInterval(t);
  }, []);
  if (!a.length) return null;
  return (
    <div style={{ margin: '0 0 10px', padding: '10px 14px', borderRadius: 8, border: '1px solid #E24B4A', background: 'rgba(226,75,74,0.08)', color: '#B3302F', fontSize: 14 }}>
      <b>Needs attention today</b>
      {a.map((l, i) => <div key={i} style={{ marginTop: 4 }}>{l}</div>)}
    </div>
  );
}
